<template>
  <router-view />
</template>

<script setup>
import { inject } from 'vue';

const emitter = inject('emitter');

emitter.$emit('initFavicon');
</script>
